<div class="blank-page" style="min-height: 768px; text-align: center">
  <h2>company-approval-action works!</h2>
</div>
